import {getVisibleOnPlan} from "@/api/company";
import {ActionTree, GetterTree, MutationTree} from "vuex";
import {IBillingStarterPlanVisibility} from "@/utils/plan";

export interface PlanState {
    visibleOnPlan: IBillingStarterPlanVisibility
}

const state: PlanState = {
    visibleOnPlan: {},
}

const getters: GetterTree<PlanState, any> = {
    visibleOnPlan({visibleOnPlan}) {
        return visibleOnPlan
    },
}

const actions: ActionTree<PlanState, any> = {
    async loadVisibleOnPlan({commit, state}) {
        if (state.visibleOnPlan && Object.keys(state.visibleOnPlan).length > 0) {
            return
        }
        const res = await getVisibleOnPlan()
        commit('setVisibleOnPlan', res.data)
    }
}

const mutations: MutationTree<PlanState> = {
    setVisibleOnPlan(state, visibleOnPlanState) {
        state.visibleOnPlan =  visibleOnPlanState
    }
}

export default {
    namespaced: false,
    state,
    getters,
    actions,
    mutations
}
